"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET = exports.NOVAGE_SKINCARE_LABEL = void 0;
const WIDGET = exports.WIDGET = 'widget';
const NOVAGE_SKINCARE_LABEL = exports.NOVAGE_SKINCARE_LABEL = 'novage-skincare-label';